export const NAV_RAIL_EXPANDED_WIDTH = 230
export const NAV_RAIL_COLLAPSED_WIDTH = 50
export const NAV_DRAWER_WIDTH = 300
export const NAV_EXPAND_MIN_WIDTH_PX = 1460
// Must match the `nav-expanded` variant in styles/utilities.css.
export const NAV_RAIL_RESPONSIVE_EXPAND_MIN_WIDTH_PX = 1200
